module.exports = __webpack_public_path__ + "media/images/CM-logo-yellow-5ffe76abb85bb3bf23ddda8e7486740c.png";